/* eslint-disable react/prop-types */
import React from "react";

export const AppleLogo = ({ onClick, className }) => {
	return (
		<svg
			className={className}
			onClick={onClick}
			width="50"
			height="50"
			viewBox="0 0 50 50"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_9647_631)">
				<path
					d="M25 0.5C38.531 0.5 49.5 11.469 49.5 25C49.5 38.531 38.531 49.5 25 49.5C11.469 49.5 0.5 38.531 0.5 25C0.5 11.469 11.469 0.5 25 0.5Z"
					fill="black"
					stroke="#30353C"
				/>
				<path
					d="M35.06 29.9309C34.6964 30.7777 34.2474 31.5852 33.72 32.3409C33.2233 33.0983 32.6441 33.7983 31.993 34.4279C31.4013 35.0193 30.6097 35.3678 29.774 35.4049C29.0657 35.3741 28.3699 35.2081 27.724 34.9159C27.0268 34.6121 26.2773 34.4464 25.517 34.4279C24.7364 34.4434 23.966 34.6091 23.248 34.9159C22.6277 35.196 21.9649 35.3704 21.287 35.4319C20.8609 35.4272 20.4401 35.3361 20.0501 35.1643C19.6601 34.9924 19.309 34.7433 19.018 34.4319C18.3387 33.7799 17.7331 33.0552 17.212 32.2709C16.398 31.104 15.7548 29.8267 15.302 28.4779C14.7864 27.0257 14.516 25.4979 14.502 23.9569C14.4609 22.4452 14.8359 20.9511 15.586 19.6379C16.1323 18.6885 16.9146 17.8962 17.857 17.3379C18.7856 16.7824 19.845 16.4836 20.927 16.4719C21.7439 16.5205 22.5467 16.7075 23.301 17.0249C23.9022 17.2899 24.5351 17.4761 25.184 17.5789C25.8995 17.4298 26.5988 17.2115 27.272 16.9269C28.1726 16.5622 29.14 16.3919 30.111 16.4269C31.0348 16.4503 31.9408 16.6857 32.759 17.115C33.5773 17.5444 34.2859 18.1561 34.83 18.9029C33.9684 19.361 33.2514 20.05 32.7595 20.8927C32.2676 21.7354 32.0202 22.6985 32.045 23.6739C32.0356 24.4197 32.1848 25.1589 32.4827 25.8427C32.7806 26.5264 33.2204 27.139 33.773 27.6399C34.2746 28.12 34.8599 28.504 35.5 28.7729C35.3613 29.1729 35.2147 29.5583 35.06 29.9289V29.9309ZM30.249 11.0029C30.2328 12.2927 29.7484 13.5327 28.886 14.4919C28.4437 15.0961 27.8619 15.5845 27.1901 15.9153C26.5184 16.2461 25.7766 16.4096 25.028 16.3919C25.0087 16.2353 24.9991 16.0777 24.999 15.9199C25.0425 14.6095 25.5557 13.3584 26.445 12.3949C26.9385 11.8413 27.5375 11.3919 28.207 11.0729C28.8339 10.7495 29.5195 10.5557 30.223 10.5029C30.2409 10.669 30.2496 10.8359 30.249 11.0029V11.0029Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_9647_631">
					<rect width="50" height="50" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
